import { render } from "./shop-desktop.vue?vue&type=template&id=466f6084"
import script from "./shop-desktop.vue?vue&type=script&lang=ts"
export * from "./shop-desktop.vue?vue&type=script&lang=ts"
script.render = render

export default script